@if (toastService.toast(); as toast) {
  <div
    class="toast"
    [class.toast-success]="toast.type === 'success'"
    [class.toast-error]="toast.type === 'error'"
    [attr.role]="toast.type === 'error' ? 'alert' : 'status'"
  >

    <span class="toast-icon">
      {{ toast.type === 'success' ? '✓' : '!' }}
    </span>

    <span class="toast-message">
      {{ toast.message }}
    </span>

  </div>
}